import React, { useState, useEffect } from 'react';
import './Toast.css';

/**
 * Toast notification component
 * @param {Object} props - Component props
 * @param {string} props.message - Message to display
 * @param {string} props.type - Toast type ('error', 'success', 'info')
 * @param {number} props.duration - Display duration in ms
 * @param {boolean} props.show - Whether to show the toast
 * @param {function} props.onClose - Function to call when toast closes
 */
const Toast = ({ message, type = 'info', duration = 3000, show, onClose }) => {
  const [visible, setVisible] = useState(show);

  useEffect(() => {
    setVisible(show);
    
    let timer;
    if (show) {
      timer = setTimeout(() => {
        setVisible(false);
        if (onClose) onClose();
      }, duration);
    }
    
    return () => {
      if (timer) clearTimeout(timer);
    };
  }, [show, duration, onClose]);

  if (!visible) return null;

  return (
    <div className={`toast-container ${type}`}>
      <div className="toast-message">{message}</div>
      <button className="toast-close" onClick={() => {
        setVisible(false);
        if (onClose) onClose();
      }}>×</button>
    </div>
  );
};

export default Toast; 